export const PWA_UPDATE_AVAILABLE_EVENT = "imobi:pwa-update-available";
export const SERVICE_WORKER_VERSION = "0.1.70";

function reloadOnce(): void {
  window.setTimeout(() => {
    window.location.reload();
  }, 1200);
}

function activateWaitingWorker(registration: ServiceWorkerRegistration): boolean {
  if (!registration.waiting) {
    return false;
  }

  registration.waiting.postMessage({ type: "SKIP_WAITING" });
  reloadOnce();
  return true;
}

export function applyServiceWorkerUpdate(registration: ServiceWorkerRegistration | null): void {
  if (!registration) {
    window.location.reload();
    return;
  }

  if (activateWaitingWorker(registration)) {
    return;
  }

  const installingWorker = registration.installing;
  if (installingWorker) {
    installingWorker.addEventListener("statechange", () => {
      if (installingWorker.state === "installed") {
        activateWaitingWorker(registration);
      }
    });
    return;
  }

  registration
    .update()
    .then(() => {
      if (!activateWaitingWorker(registration)) {
        reloadOnce();
      }
    })
    .catch(() => {
      window.location.reload();
    });
}

function notifyUpdate(registration: ServiceWorkerRegistration): void {
  if (registration.waiting) {
    window.dispatchEvent(new CustomEvent(PWA_UPDATE_AVAILABLE_EVENT, { detail: registration }));
  }
}

export function registerServiceWorker(): void {
  if (!("serviceWorker" in navigator) || import.meta.env.DEV) {
    return;
  }

  let isRefreshing = false;
  navigator.serviceWorker.addEventListener("controllerchange", () => {
    if (isRefreshing) {
      return;
    }

    isRefreshing = true;
    window.location.reload();
  });

  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register(`/sw.js?v=${SERVICE_WORKER_VERSION}`, { updateViaCache: "none" })
      .then((registration) => {
        notifyUpdate(registration);
        registration.update().then(() => notifyUpdate(registration)).catch(() => undefined);

        registration.addEventListener("updatefound", () => {
          const pendingWorker = registration.installing;

          pendingWorker?.addEventListener("statechange", () => {
            if (pendingWorker.state === "installed" && navigator.serviceWorker.controller) {
              notifyUpdate(registration);
            }
          });
        });

        window.setInterval(() => {
          registration.update().catch(() => undefined);
        }, 60 * 60 * 1000);

        window.addEventListener("visibilitychange", () => {
          if (document.visibilityState === "visible") {
            registration.update().catch(() => undefined);
          }
        });
      })
      .catch((error) => {
        console.error("Falha ao registrar service worker do IMOBI", error);
      });
  });
}
